<template>
  <div
    class="datepicker-date"
    @click.stop.self="openCalendarNewAction()"
    :class="{'is-today': isToday, 'is-current-month' : isCurrentMonth}">
    <router-link
      class="date-item"
      tag="button"
      :to="{name: 'CalendarDay', params: { year: dateDetail.year, month: dateDetail.month, day: dateDetail.day, panel: 'rdvs' }}">
      {{ day }}<span v-if="day === '01'"> {{ monthSmall }}</span>
    </router-link>
    <div
      v-if="totalEvents.length <= 4"
      class="datepicker-events"
      @click.stop.self="openCalendarNewAction()">
      <!-- <a href="#" class="datepicker-event is-size-6 is-warning">
        <span class="datepicker-event-numero">1</span>
        <span class="datepicker-event-label"><strong>Mandat:</strong>&nbsp;CompanyName - ProgramName</span>
      </a> -->
      <router-link
        v-for="rdv in todayRdvs"
        :key="rdv.pk"
        class="datepicker-event is-size-6 is-rdv"
        tag="a"
        :to="{name: 'CalendarDay', params: { year: dateDetail.year, month: dateDetail.month, day: dateDetail.day, panel: 'rdvs' }}">
        <span class="datepicker-event-numero">1</span>
        <span class="datepicker-event-label"><strong>{{ rdv.rdv_type }}</strong>&nbsp;{{ rdv.contact.last_name }} {{ rdv.contact.first_name }}</span>
      </router-link>
      <router-link
        v-for="reminder in todayReminders"
        :key="reminder.pk"
        class="datepicker-event is-size-6 is-danger"
        tag="a"
        :to="{name: 'CalendarDay', params: { year: dateDetail.year, month: dateDetail.month, day: dateDetail.day, panel: 'reminders' }}">
        <span class="datepicker-event-numero">1</span>
        <span class="datepicker-event-label"><strong>Rappel</strong>&nbsp;{{ reminder.title }}</span>
      </router-link>
      <router-link
        v-for="option in todayOptions"
        :key="option.pk"
        class="datepicker-event is-size-6 is-success"
        tag="a"
        :to="{name: 'CalendarDay', params: { year: dateDetail.year, month: dateDetail.month, day: dateDetail.day, panel: 'options' }}">
        <span class="datepicker-event-numero">1</span>
        <span class="datepicker-event-label"><strong>Fin option :</strong>&nbsp;<span v-if="'lot' in option && option.lot.ref">{{ option.lot.ref }} {{ option.program.name }} </span></span>
      </router-link>
      <!-- <a href="#" class="datepicker-event is-size-6 is-success" v-if="totalEvents > 2">
        <span class="datepicker-event-numero">1</span>
        <span class="datepicker-event-label"><strong>Fin option:</strong>&nbsp;34RTGYH</span>
      </a>
      <a href="#" class="datepicker-event is-size-6 is-draft" v-if="totalEvents >=3">
        <span class="datepicker-event-numero">1</span>
        <span class="datepicker-event-label"><strong>Fin de validité:</strong>&nbsp;Fanny Gibert</span>
      </a> -->
    </div>
    <div
      v-else
      class="datepicker-events"
      @click.stop.self="openCalendarNewAction()">
      <!-- <a href="#" class="datepicker-event is-size-6 is-warning" v-if="totalEvents > 5">
        <span class="datepicker-event-numero">4</span>
        <span class="datepicker-event-label"><strong>Mandats</strong> arrivant à expiration</span>
      </a> -->
      <router-link
        v-if="todayRdvs.length > 1"
        class="datepicker-event is-size-6 is-rdv"
        tag="a"
        :to="{name: 'CalendarDay', params: { year: dateDetail.year, month: dateDetail.month, day: dateDetail.day, panel: 'rdvs' }}">
        <span class="datepicker-event-numero">{{ todayRdvs.length }}</span>
        <span class="datepicker-event-label"><strong>Rendez-vous</strong></span>
      </router-link>
      <router-link
        v-if="todayReminders.length > 1"
        class="datepicker-event is-size-6 is-danger"
        tag="a"
        :to="{name: 'CalendarDay', params: { year: dateDetail.year, month: dateDetail.month, day: dateDetail.day, panel: 'reminders' }}">
        <span class="datepicker-event-numero">{{ todayReminders.length }}</span>
        <span class="datepicker-event-label"><strong>Rappels</strong></span>
      </router-link>
      <router-link
        v-if="todayOptions.length > 1"
        class="datepicker-event is-size-6 is-success"
        tag="a"
        :to="{name: 'CalendarDay', params: { year: dateDetail.year, month: dateDetail.month, day: dateDetail.day, panel: 'options' }}">
        <span class="datepicker-event-numero">{{ todayOptions.length }}</span>
        <span class="datepicker-event-label"><strong>Fin options</strong></span>
      </router-link>
      <!-- <a href="#" class="datepicker-event is-size-6 is-success" v-if="totalEvents > 6">
        <span class="datepicker-event-numero">6</span>
        <span class="datepicker-event-label"><strong>Options</strong>&nbsp;arrivant à expiration</span>
      </a>
      <a href="#" class="datepicker-event is-size-6 is-draft" v-if="totalEvents > 8">
        <span class="datepicker-event-numero">1</span>
        <span class="datepicker-event-label">Documents en fin de validité</span>
      </a> -->
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { concat } from 'lodash'
import { Quickview } from '@/mixins'

export default {
  name: 'CalendarMonthItem',
  mixins: [Quickview],
  props: {
    date: {
      type: Object,
      required: true
    },
    options: Array,
    rdvs: Array,
    reminders: Array,
    currentMonth: Object
  },
  data () {
    return {}
  },
  computed: {
    dateDetail () {
      let result = {
        year: moment(this.date).format('YYYY'),
        month: moment(this.date).format('MM'),
        day: moment(this.date).format('DD')
      }
      return result
    },
    day () {
      return this.date.format('DD')
    },
    month () {
      return this.date.format('MM')
    },
    monthSmall () {
      return this.date.format('MMM')
    },
    isToday () {
      return this.date.isSame(moment(), 'day')
    },
    isCurrentMonth () {
      return this.currentMonth.format('MM') === this.date.format('MM')
    },
    totalEvents () {
      return concat(this.todayRdvs, this.todayReminders, this.todayOptions)
    },
    todayOptions () {
      let result = []
      for (let option of this.options) {
        if (moment(option.end_date).isSame(this.date, 'day')) result.push(option)
      }
      return result
    },
    todayRdvs () {
      let result = []
      for (let rdv of this.rdvs) {
        if (moment(rdv.date).isSame(this.date, 'day')) result.push(rdv)
      }
      return result
    },
    todayReminders () {
      let result = []
      for (let reminder of this.reminders) {
        if (moment(reminder.date).isSame(this.date, 'day')) result.push(reminder)
      }
      return result
    }
  },
  methods: {
    openCalendarNewAction (params) {
      this.$store.commit('setQuickview', { mode: 'NEW_CALENDAR_ACTION', params: { fromCalendarDate: this.date.toDate() } })
    }
  }
}
</script>

<style></style>
